import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import PainSection from './components/PainSection';
import WhyFailSection from './components/WhyFailSection';
import TransformationSection from './components/TransformationSection';
import WhoThisWorksForSection from './components/WhoThisWorksForSection';
import HowItWorksSection from './components/HowItWorksSection';
import PhilosophySection from './components/PhilosophySection';
import ServicesSection from './components/ServicesSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import CopyQuiz from '../../components/feature/CopyQuiz';
import ROICalculator from '../../components/feature/ROICalculator';
import InstantBooking from '../../components/feature/InstantBooking';
import AnimatedSection from '../../components/base/AnimatedSection';
import { useSchemaOrg, getLocalBusinessSchema, getWebPageSchema, getFAQSchema, getServiceSchema } from '../../utils/seo';

const HomePage = () => {
  // Add Schema.org structured data
  const schemas = [
    getLocalBusinessSchema(),
    getWebPageSchema(),
    getFAQSchema(),
    getServiceSchema()
  ];
  
  useSchemaOrg(schemas);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Section 1 - Hero */}
        <Hero />
        
        {/* Interactive Quiz */}
        <AnimatedSection className="py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[#34444b] mb-4">
                Test Your Copy Knowledge
              </h2>
              <p className="text-lg text-[#73807c]">
                Think you know what makes copy convert? Let's find out. (Spoiler: Most people get #3 wrong.)
              </p>
            </div>
            <CopyQuiz />
          </div>
        </AnimatedSection>

        {/* Section 2 - The Problem */}
        <PainSection />
        
        {/* Section 3 - Why Everything Else Fails */}
        <WhyFailSection />
        
        {/* ROI Calculator */}
        <AnimatedSection className="py-16 px-6 bg-gradient-to-br from-[#a4ae9e]/5 to-[#708474]/5">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[#34444b] mb-4">
                What's Better Copy Worth to You?
              </h2>
              <p className="text-lg text-[#73807c]">
                Stop guessing. See exactly how much revenue you're leaving on the table.
              </p>
            </div>
            <ROICalculator />
          </div>
        </AnimatedSection>

        {/* Section 4 - The Transformation */}
        <TransformationSection />
        
        {/* Section 5 - Who This Works For */}
        <WhoThisWorksForSection />
        
        {/* Section 6 - How It Works */}
        <HowItWorksSection />
        
        {/* Section 7 - The Philosophy */}
        <PhilosophySection />
        
        {/* Section 8 - Services Overview */}
        <ServicesSection />
        
        {/* Section 9 - FAQ */}
        <FAQSection />
        
        {/* Instant Booking */}
        <AnimatedSection className="py-16 px-6 bg-gradient-to-br from-[#708474]/5 to-[#a4ae9e]/5">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[#34444b] mb-4">
                Ready to Get Started?
              </h2>
              <p className="text-lg text-[#73807c]">
                No more email tag. Pick your time, and let's talk about growing your business.
              </p>
            </div>
            <InstantBooking />
          </div>
        </AnimatedSection>

        {/* Final CTA */}
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
